module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABDElEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EigVsfYCKoBqBqoAq4BiAbqAefhv/////9+xdIAjX8h4GgdTfnBKZs9PXZEO2/NdV1jn9c0OqbUA1AdVAkJwdnB6+5eSzC+2Wq/IsQmTeJqmcCnEJWX4NqgDga4aQVK3r794ZsvjNhzbyFC/rv2yTPWdKx4Mja2J1PYDZMn+5XuAOuobprP1B/8MZbR3Ib7kZl31BxuxqWdTCrLnTjLagGrP7z2nB7c/fct12zrmn5vm/J29bW4rvhHl4Nmx9UnXr6/vnzJ9bh9w/6Vx3Y5L3lOUIDdj1bHhRvvrIgriZj1XHvbU+BIggNxCCyNAxKAABPcyXHM7TFJgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/FJ.png
// module id = 1137
// module chunks = 0